// eslint-disable-next-line no-empty-label
/*
 * @Author: Administrator
 * @Date:   2018-12-20 11:18:15
 * @Last Modified by:   Administrator
 * @Last Modified time: 2019-09-26 11:11:54
 */

import Vue from 'vue';
import {getSessionStore} from '@/config/mUtils';

/**权限指令**/
const has = Vue.directive('has', {
    'bind': function (el, binding, vnode) {
        if (!Vue.prototype.$_has(binding.value)) {
            el.style.display = 'none';
        }
    }
});
// 权限检查方法

Vue.prototype.$_has = function (value) {
    let isExist = false,
        btnPermissionsStr = getSessionStore('authArr');

    if (!btnPermissionsStr) {
        return false;
    }
    if (btnPermissionsStr.indexOf(value) > -1) {
        isExist = true;
    }
    return isExist;
};
export {has};
